
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/financial",
      function () {
        return require("private-next-pages/en/ir/financial/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/financial"])
      });
    }
  